import { render, staticRenderFns } from "./AppFooterMenu.vue?vue&type=template&id=7f05144e&lang=pug&"
import script from "./AppFooterMenu.vue?vue&type=script&lang=js&"
export * from "./AppFooterMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports